import React, { useEffect } from 'react';

import { faCheck, faExclamationTriangle, faInfoCircle, faSpinner,faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Toast.css';

const Toast = ({ 
  message, 
  type = 'success', 
  duration = 3000, 
  onClose,
  isVisible = true 
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose && onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return faCheck;
      case 'error':
        return faExclamationTriangle;
      case 'info':
        return faInfoCircle;
      case 'loading':
        return faSpinner;
      default:
        return faCheck;
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`toast toast-${type} ${isVisible ? 'toast-visible' : ''}`}>
      <div className="toast-content">
        <FontAwesomeIcon icon={getIcon()} className="toast-icon" />
        <span className="toast-message">{message}</span>
      </div>
      {onClose && type !== 'loading' && (
        <button className="toast-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
};

export default Toast;
